module.exports = __webpack_public_path__ + "img/badge_salabam_shop.deaa61cf.jpg";